import { render, staticRenderFns } from "./Galleries.vue?vue&type=template&id=2b0bcfa4&scoped=true&"
import script from "./Galleries.vue?vue&type=script&lang=js&"
export * from "./Galleries.vue?vue&type=script&lang=js&"
import style0 from "./Galleries.vue?vue&type=style&index=0&id=2b0bcfa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0bcfa4",
  null
  
)

export default component.exports